module.exports = __webpack_public_path__ + "img/logo-sm.20211204-2.b4a3ef12.png";